import { CubeRawRow } from "./kpi-props.schema";
import { CubeBasicFilters, CubeFilter, CubeSummaryResponse } from "./kpi.types";

export const buildBaseFilters = (cubeFilter: CubeBasicFilters): CubeFilter[] => {
    const filters: CubeFilter[] = [
        {
            dimension: "siniestros_salud.cd_cliente",
            operator: "equals",
            values: [cubeFilter.idClient],
        },
        {
            dimension: "siniestros_salud.poliza",
            operator: "equals",
            values: [cubeFilter.policy],
        },
    ];

    if (cubeFilter.idQuotes !== undefined && cubeFilter.idQuotes !== null) {
        if (cubeFilter.idQuotes.length > 0) {
            filters.push({
                dimension: "siniestros_salud.cd_ramo_cotizacion",
                operator: "equals",
                values: cubeFilter.idQuotes,
            });
        }
    }

    return filters;
};

export const buildBaseFiltersTableSummary = (cubeFilter: CubeBasicFilters): CubeFilter[] => {
    const filters: CubeFilter[] = [
        {
            dimension: "siniestros_salud_mensualizado.cd_cliente",
            operator: "equals",
            values: [cubeFilter.idClient],
        },
        {
            dimension: "siniestros_salud_mensualizado.poliza",
            operator: "equals",
            values: [cubeFilter.policy],
        },
    ];

    if (cubeFilter.idQuotes !== undefined && cubeFilter.idQuotes !== null) {
        if (cubeFilter.idQuotes.length > 0) {
            filters.push({
                dimension: "siniestros_salud_mensualizado.cd_ramo_cotizacion",
                operator: "equals",
                values: cubeFilter.idQuotes,
            });
        }
    }

    return filters;
};

export const groupByAccident = (cubeSummaryResponse: CubeSummaryResponse[], mostValue = 4): CubeSummaryResponse[] => {
    const sorted = [...cubeSummaryResponse].sort((cubeA, cubeB) => cubeB.amount - cubeA.amount);

    if (sorted.length <= mostValue) return sorted;

    const highestRated = sorted.slice(0, mostValue);
    const others = sorted.slice(mostValue);

    const grouped: CubeSummaryResponse = {
        type: "Otros",
        amount: others.reduce((acc, curr) => acc + curr.amount, 0),
        total: others.reduce((acc, curr) => acc + curr.total, 0),
    };

    return [...highestRated, grouped];
};

export const formatCurrency = (val: number): string =>
    `$ ${val.toLocaleString("es-EC", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;

export const formatPercent = (val: number): string => `${val.toFixed(2)} %`;

export const formatDate = (rawDate: string): string => {
    if (!rawDate) return "-";

    const formattedDate = new Date(rawDate);

    return formattedDate.toLocaleDateString("es-EC", {
        month: "2-digit",
        year: "numeric",
        timeZone: "UTC",
    });
};

export const mapCubeData = (cubeResponse: CubeRawRow[], dimension: string): CubeSummaryResponse[] => {
    return cubeResponse.map(item => ({
        type: String(item[dimension] ?? "Desconocido"),
        amount: Number(item["siniestros_salud.total_pagado"] ?? 0),
        total: Number(item["siniestros_salud.count"] ?? 0),
    }));
};
